import styled, { css } from 'styled-components/macro';
import { colorBrandYamahaRed, colorCoreBlack900Base } from '@yme/tokens/colors';
import { RegularTextLevel3 } from '@yme/tokens/typography';
export const OverviewListStyled = styled.ul `
  margin: 12px 0 0;
  padding: 0;
  list-style: none;
`;
export const OverviewItemStyled = styled(RegularTextLevel3) `
  position: relative;
  padding-left: 36px;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    display: block;
    width: 24px;
    height: 24px;
    background-image: ${({ icon }) => icon && `url(${icon})`};
    background-repeat: no-repeat;
    background-position: center;
  }

  ${({ isRoundIcon }) => isRoundIcon &&
    css `
      display: flex;
      align-items: center;
      padding-left: 56px;
      min-height: 40px;

      &::before {
        top: 50%;
        width: 40px;
        height: 40px;
        border: 1px solid ${colorBrandYamahaRed};
        border-radius: 50%;
        transform: translateY(-50%);
      }
    `}

  &:not(:last-child) {
    margin-bottom: 12px;
  }

  a {
    color: ${colorCoreBlack900Base};
  }
`;
